import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Layout from '../components/Layout';
import WhatsAppIcon from '../components/WhatsAppIcon';
import MeioEnvioLabel from '../components/MeioEnvioLabel';
import { salesService, viaCepService, usersService, operadorasService, planosService, apiConfigService, catalogoPlanosService } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { 
  maskCPF, maskCNPJ, maskPhone, maskCEP, maskMoney, unmaskMoney,
  validateCPF, validateCNPJ, normalizeCpf, maskCodigoPap, validateCodigoPap,
  normalizeNumeroOrdemOnda, validateNumeroOrdemOnda
} from '../utils/masks';
import { TIPOS_COMPLEMENTO, serializarComplementosCnpj } from '../utils/complementosEndereco';
import {
  MARCAS,
  isMarcaValida,
  formatMarcaLabel,
  marcaExigeNumeroOrdem,
  resolvePapMarcas,
  resolveMarcasPermitidas,
  vendedorTemPapDaMarca as usuarioTemPapDaMarca,
  vendedorPodeVenderMarca as usuarioPodeVenderMarca,
  formatMarcasPermitidasErro
} from '../utils/marcas';
import '../styles/NovaVenda.css';

const NovaVenda = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(false);
  const [buscandoCnpj, setBuscandoCnpj] = useState(false);
  const [buscandoCpf, setBuscandoCpf] = useState(false);
  const cpfBuscadoRef = useRef('');

  // Seletor de vendedor (apenas supervisor): ele + subordinados
  const [vendedorId, setVendedorId] = useState(null);
  const [opcoesVendedor, setOpcoesVendedor] = useState([]);
  
  // Estado do formulário
  const [formData, setFormData] = useState({
    tipo_cliente: 'cpf',
    documento: '',
    razao_social: '',
    estado_cnpj: '',
    nome_cliente: '',
    telefone: '',
    telefone2: '',
    email: '',
    cpf: '',
    nome_representante: '',
    rg: '',
    nome_mae: '',
    data_nascimento: '',
    cep: '',
    logradouro: '',
    bairro: '',
    cidade: '',
    estado: '',
    estado_completo: '',
    numero: '',
    complemento1: '',
    complemento2: '',
    complemento3: '',
    data_agendamento1: '',
    periodo_agendamento1: 'manha',
    data_agendamento2: '',
    periodo_agendamento2: '',
    aceita_antecipacao: false,
    observacao_instalacao: '',
    data_vencimento: 21,
    valor_total: '',
    observacao_venda: '',
    envio_aceite: null,
    marca: '',
    vendedor_codigo_pap: '',
    vendedor_login_pap: '',
    numero_ordem: '',
    data_instalacao: ''
  });

  const [errors, setErrors] = useState({});
  const [operadoraSelecionada, setOperadoraSelecionada] = useState(null);
  const [operadoraObj, setOperadoraObj] = useState(null);
  const [planosList, setPlanosList] = useState([]);
  const [planoSelecionadoId, setPlanoSelecionadoId] = useState(null);
  const [showPlanoManualModal, setShowPlanoManualModal] = useState(false);
  const [planoManualForm, setPlanoManualForm] = useState({ texto: '', valor: '' });
  const [produtosPfCatalogo, setProdutosPfCatalogo] = useState([]);
  const [produtosSelecionados, setProdutosSelecionados] = useState([]);
  const [buscaProdutoPf, setBuscaProdutoPf] = useState('');
  const [loadingProdutosPf, setLoadingProdutosPf] = useState(false);
  const [operadoraViabilidadeJson, setOperadoraViabilidadeJson] = useState(null);
  const [documentosAnexos, setDocumentosAnexos] = useState([]);
  const [envioAceiteSelecionado, setEnvioAceiteSelecionado] = useState(''); // 'sms', 'email' ou 'whatsapp'
  const [showResumoModal, setShowResumoModal] = useState(false);
  const [saleDataToSubmit, setSaleDataToSubmit] = useState(null);
  const [consultandoEmpresas, setConsultandoEmpresas] = useState(false);
  const [showCnpjDisponivelModal, setShowCnpjDisponivelModal] = useState(false);
  const [empresasDisponiveis, setEmpresasDisponiveis] = useState([]);
  const [cnpjSelecionado, setCnpjSelecionado] = useState('');
  const [cpfTinhaCnpjDisponivel, setCpfTinhaCnpjDisponivel] = useState(false);
  const [showRgModal, setShowRgModal] = useState(false);
  const [rgTemp, setRgTemp] = useState('');
  const [etapaCnpjModal, setEtapaCnpjModal] = useState('escolha');
  const [vendedorPapMarcas, setVendedorPapMarcas] = useState([]);
  const [vendedorMarcasPermitidas, setVendedorMarcasPermitidas] = useState([]);
  const [codigoPap, setCodigoPap] = useState('');
  const [loginPap, setLoginPap] = useState('');

  const vendedorPodeVenderMarca = (marca) => usuarioPodeVenderMarca({ pap_marcas: vendedorPapMarcas, marcas_permitidas: vendedorMarcasPermitidas }, marca);
  const vendedorTemPapDaMarca = (marca) => usuarioTemPapDaMarca({ pap_marcas: vendedorPapMarcas }, marca);
  const exigeCamposPap = formData.tipo_cliente === 'cpf' && vendedorTemPapDaMarca(formData.marca);
  const marcasDisponiveis = MARCAS.filter((m) => vendedorMarcasPermitidas.includes(m.id));

  // Complementos tipados (CNPJ): até 3 pares tipo + valor
  const [complementosCnpj, setComplementosCnpj] = useState([{ tipo: '', valor: '' }]);

  // Meios de envio disponíveis por operadora (apenas para essas operadoras o envio de aceite é obrigatório)
  const meiosPorOperadora = {
    vivo: ['sms', 'email'],
    gigamais: ['sms', 'email', 'whatsapp'],
    tim: ['sms', 'email', 'whatsapp'],
    ligga: ['sms', 'email', 'whatsapp'],
    nio: ['sms', 'email', 'whatsapp']
  };

  const getMeiosEnvioAceite = (operadora, tipoCliente) => {
    const chave = (operadora || '').toLowerCase().trim();
    const base = meiosPorOperadora[chave] || [];
    if (tipoCliente === 'cpf' && chave === 'vivo' && !base.includes('whatsapp')) {
      return [...base, 'whatsapp'];
    }
    if (tipoCliente === 'cnpj') {
      return base.filter((m) => m !== 'whatsapp');
    }
    return base;
  };

  const getEnvioAceitePadrao = (operadora, tipoCliente) => {
    if (tipoCliente !== 'cpf' || !operadora) return '';
    const meios = getMeiosEnvioAceite(operadora, tipoCliente);
    return meios.includes('whatsapp') ? 'whatsapp' : '';
  };

  // Função paraFormatar meios selecionados (vivo:sms,email)
  const formatarEnvioAceite = (meios) => {
    return operadoraSelecionada ? `${operadoraSelecionada}:${meios.join(',')}` : null;
  };

  // Verifica se a operadora requer envio de aceite (está na lista de operadoras permitidas)
  const operadoraRequerEnvioAceite = () => {
    return operadoraSelecionada && 
           meiosPorOperadora.hasOwnProperty(operadoraSelecionada.toLowerCase().trim());
  };

  const PLANO_MANUAL_ID = 'manual';

  // Buscar dados por CPF quando documento (PF) ou cpf (PJ) tiver 11 dígitos válidos
  useEffect(() => {
    const tipoCliente = formData.tipo_cliente;
    const buscarPorCpf = async (cpfLimpo) => {
      if (cpfBuscadoRef.current === cpfLimpo) return;
      if (!validateCPF(maskCPF(cpfLimpo))) return;

      try {
        setBuscandoCpf(true);
        cpfBuscadoRef.current = cpfLimpo;
        const data = await apiConfigService.buscarCpf(cpfLimpo);

        const formatarData = (dt) => {
          if (!dt || dt === 'SEM RESULTADO') return '';
          const parts = String(dt).replace(/\\\//g, '/').split('/');
          if (parts.length === 3) {
            const [d, m, y] = parts;
            return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
          }
          return '';
        };

        const tel = data.TELEFONES || '';
        const telFormatado = tel ? maskPhone(tel.replace(/\D/g, '').slice(0, 11)) : '';

        setFormData(prev => {
          const updates = {
            data_nascimento: formatarData(data.DT_NASCIMENTO) || prev.data_nascimento,
            nome_mae: data.NOME_MAE || prev.nome_mae,
            telefone: telFormatado || prev.telefone,
            email: (data.EMAIL && data.EMAIL !== 'SEM RESULTADO') ? data.EMAIL : prev.email
          };
          if (tipoCliente === 'cpf') {
            updates.nome_cliente = data.NOME || prev.nome_cliente;
          } else if (tipoCliente === 'cnpj') {
            // Quando for CNPJ, preenche o nome do representante
            updates.nome_representante = data.NOME || prev.nome_representante;
          }
          return { ...prev, ...updates };
        });
      } catch (err) {
        console.error('Erro ao buscar CPF:', err);
        cpfBuscadoRef.current = '';
      } finally {
        setBuscandoCpf(false);
      }
    };

    if (formData.tipo_cliente === 'cpf') {
      const doc = formData.documento.replace(/\D/g, '');
      if (doc.length === 11) {
        buscarPorCpf(doc);
      } else {
        cpfBuscadoRef.current = '';
      }
    } else if (formData.tipo_cliente === 'cnpj') {
      const cpfDoc = formData.cpf.replace(/\D/g, '');
      if (cpfDoc.length === 11) {
        buscarPorCpf(cpfDoc);
      } else {
        cpfBuscadoRef.current = '';
      }
    }
  }, [formData.tipo_cliente, formData.documento, formData.cpf]);

  // Receber dados da consulta de viabilidade se existirem
  useEffect(() => {
    if (location.state) {
      const { cep, numero, operadora_selecionada, operadora_viabilidade_json } = location.state;
      
      if (cep) {
        setFormData(prev => ({
          ...prev,
          cep: maskCEP(cep)
        }));
      }
      
      if (numero) {
        setFormData(prev => ({
          ...prev,
          numero: numero
        }));
      }
      
      if (operadora_selecionada) {
        setOperadoraSelecionada(operadora_selecionada);
      }
      
      if (operadora_viabilidade_json) {
        setOperadoraViabilidadeJson(operadora_viabilidade_json);
      }
    }
  }, [location.state]);

  // Quando há operadora selecionada (da consulta de viabilidade), buscar operadora e planos
  useEffect(() => {
    if (!operadoraSelecionada || typeof operadoraSelecionada !== 'string') {
      setOperadoraObj(null);
      setPlanosList([]);
      setPlanoSelecionadoId(null);
      setEnvioAceiteSelecionado('');
      return;
    }
    const nomeNormalizado = operadoraSelecionada.toLowerCase().trim();
    let cancelled = false;
    const load = async () => {
      try {
        const operadoras = await operadorasService.getAll();
        if (cancelled) return;
        const operadora = operadoras.find(
          op => (op.nome && op.nome.toLowerCase() === nomeNormalizado)
        );
        setOperadoraObj(operadora || null);
        if (operadora?.planos_habilitados && operadora.id) {
          const planos = await planosService.getByOperadora(operadora.id);
          if (cancelled) return;
          setPlanosList(Array.isArray(planos) ? planos : []);
        } else {
          setPlanosList([]);
        }
        setPlanoSelecionadoId(null);
        setEnvioAceiteSelecionado(getEnvioAceitePadrao(operadoraSelecionada, formData.tipo_cliente));
      } catch (err) {
        console.error('Erro ao carregar operadora/planos:', err);
        if (!cancelled) {
          setOperadoraObj(null);
          setPlanosList([]);
          setEnvioAceiteSelecionado(getEnvioAceitePadrao(operadoraSelecionada, formData.tipo_cliente));
        }
      }
    };
    load();
    return () => { cancelled = true; };
  }, [operadoraSelecionada, formData.tipo_cliente]);

  // Catálogo PF NEO para vendas CPF
  useEffect(() => {
    if (formData.tipo_cliente !== 'cpf') {
      setProdutosPfCatalogo([]);
      setProdutosSelecionados([]);
      setBuscaProdutoPf('');
      return;
    }
    let cancelled = false;
    const loadPf = async () => {
      try {
        setLoadingProdutosPf(true);
        const data = await catalogoPlanosService.listPfNeo();
        if (!cancelled) setProdutosPfCatalogo(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error('Erro ao carregar produtos PF:', err);
        if (!cancelled) setProdutosPfCatalogo([]);
      } finally {
        if (!cancelled) setLoadingProdutosPf(false);
      }
    };
    loadPf();
    return () => { cancelled = true; };
  }, [formData.tipo_cliente]);

  const recalcularValorTotalProdutos = (lista) => {
    const soma = lista.reduce((acc, p) => {
      const v = parseFloat(String(p.valor_negociado).replace(',', '.')) || 0;
      const q = parseInt(p.quantidade, 10) || 1;
      return acc + v * q;
    }, 0);
    setFormData(prev => ({
      ...prev,
      valor_total: maskMoney(String(Math.round(soma * 100)))
    }));
  };

  const adicionarProdutoPf = (item) => {
    if (produtosSelecionados.some(p => p.catalogo_plano_id === item.id)) return;
    const valorPadrao = parseFloat(item.valor_padrao) || 0;
    const novo = {
      catalogo_plano_id: item.id,
      nome_neo: item.nome_neo || item.titulo,
      filtro_busca: item.filtro_busca || null,
      valor_negociado: valorPadrao,
      quantidade: 1
    };
    const novaLista = [...produtosSelecionados, novo];
    setProdutosSelecionados(novaLista);
    recalcularValorTotalProdutos(novaLista);
    setBuscaProdutoPf('');
    if (errors.produtos_pf) setErrors(prev => ({ ...prev, produtos_pf: '' }));
  };

  const removerProdutoPf = (catalogoPlanoId) => {
    const novaLista = produtosSelecionados.filter(p => p.catalogo_plano_id !== catalogoPlanoId);
    setProdutosSelecionados(novaLista);
    recalcularValorTotalProdutos(novaLista);
  };

  const atualizarProdutoPf = (catalogoPlanoId, field, value) => {
    const novaLista = produtosSelecionados.map(p => {
      if (p.catalogo_plano_id !== catalogoPlanoId) return p;
      if (field === 'valor_negociado') {
        const num = typeof value === 'string' ? parseFloat(unmaskMoney(value)) : value;
        return { ...p, valor_negociado: isNaN(num) ? 0 : num };
      }
      if (field === 'quantidade') {
        const q = parseInt(value, 10) || 1;
        return { ...p, quantidade: q < 1 ? 1 : q };
      }
      return p;
    });
    setProdutosSelecionados(novaLista);
    recalcularValorTotalProdutos(novaLista);
  };

  const produtosPfFiltrados = produtosPfCatalogo.filter(item => {
    if (produtosSelecionados.some(p => p.catalogo_plano_id === item.id)) return false;
    const q = buscaProdutoPf.trim().toLowerCase();
    if (!q) return true;
    return (
      (item.nome_neo || '').toLowerCase().includes(q) ||
      (item.titulo || '').toLowerCase().includes(q) ||
      (item.filtro_busca || '').toLowerCase().includes(q)
    );
  });

  // Carregar "Eu (Supervisor)" + subordinados quando for supervisor
  useEffect(() => {
    if (user?.role !== 'supervisor') return;
    const load = async () => {
      const eu = { value: user.id, label: `Eu (${user.nome || user.username || 'Supervisor'})` };
      setOpcoesVendedor([eu]);
      setVendedorId(user.id);
      try {
        const subordinados = await usersService.getVendedoresBySupervisor(user.id);
        const extras = (subordinados || []).map(s => ({
          value: s.id,
          label: s.nome || s.username || `ID ${s.id}`
        }));
        setOpcoesVendedor([eu, ...extras]);
      } catch (err) {
        console.error('Erro ao carregar subordinados:', err);
      }
    };
    load();
  }, [user?.id, user?.role, user?.nome, user?.username]);

  // Verificar PAP e marcas permitidas do vendedor
  useEffect(() => {
    const verificarDadosVendedor = async () => {
      if (user?.role === 'vendedor') {
        try {
          const usuarioAtual = await usersService.getById(user.id);
          setVendedorPapMarcas(resolvePapMarcas(usuarioAtual));
          setVendedorMarcasPermitidas(resolveMarcasPermitidas(usuarioAtual));
        } catch (err) {
          console.error('Erro ao buscar dados do usuário:', err);
          setVendedorPapMarcas([]);
          setVendedorMarcasPermitidas([]);
        }
        return;
      }
      if (user?.role === 'supervisor' && vendedorId) {
        try {
          const vendedor = await usersService.getById(vendedorId);
          setVendedorPapMarcas(resolvePapMarcas(vendedor));
          setVendedorMarcasPermitidas(resolveMarcasPermitidas(vendedor));
        } catch (err) {
          console.error('Erro ao verificar dados do vendedor:', err);
          setVendedorPapMarcas([]);
          setVendedorMarcasPermitidas([]);
        }
        return;
      }
      setVendedorPapMarcas([]);
      setVendedorMarcasPermitidas([]);
    };
    verificarDadosVendedor();
  }, [user, vendedorId]);

  // Pré-selecionar marca quando vendedor tem apenas uma permitida
  useEffect(() => {
    if (formData.tipo_cliente !== 'cpf') return;
    if (vendedorMarcasPermitidas.length === 1) {
      const unicaMarca = vendedorMarcasPermitidas[0];
      setFormData(prev => {
        if (prev.marca === unicaMarca) return prev;
        return {
          ...prev,
          marca: unicaMarca,
          ...(!marcaExigeNumeroOrdem(unicaMarca) ? { numero_ordem: '', data_instalacao: '' } : {})
        };
      });
    }
  }, [vendedorMarcasPermitidas, formData.tipo_cliente]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === 'checkbox' ? checked : value;

    // Aplicar máscaras
    if (name === 'documento') {
      newValue = formData.tipo_cliente === 'cpf' ? maskCPF(value) : maskCNPJ(value);
      
      // Validação automática para CPF
      if (formData.tipo_cliente === 'cpf' && newValue.replace(/\D/g, '').length === 11) {
        if (validateCPF(newValue)) {
          setErrors(prev => ({ ...prev, documento: '' }));
        } else {
          setErrors(prev => ({ ...prev, documento: 'CPF inválido' }));
        }
      }
    } else if (name === 'telefone' || name === 'telefone2') {
      newValue = maskPhone(value);
    } else if (name === 'cpf') {
      newValue = maskCPF(value);
      // Validação automática do CPF quando preenchido
      if (newValue.replace(/\D/g, '').length === 11) {
        if (validateCPF(newValue)) {
          setErrors(prev => ({ ...prev, cpf: '' }));
        } else {
          setErrors(prev => ({ ...prev, cpf: 'CPF inválido' }));
        }
      }
    } else if (name === 'cep') {
      newValue = maskCEP(value);
    } else if (name === 'valor_total') {
      newValue = maskMoney(value);
    } else if (name === 'vendedor_codigo_pap') {
      newValue = maskCodigoPap(value);
      if (newValue.length >= 9) {
        if (validateCodigoPap(newValue)) {
          setErrors(prev => ({ ...prev, vendedor_codigo_pap: '' }));
        } else {
          setErrors(prev => ({ ...prev, vendedor_codigo_pap: 'Código PAP inválido. Use o formato XX-###### ou XX-####### (ex: SC-339683)' }));
        }
      } else {
        setErrors(prev => ({ ...prev, vendedor_codigo_pap: '' }));
      }
    } else if (name === 'numero_ordem') {
      newValue = normalizeNumeroOrdemOnda(value);
      if (newValue.length === 11) {
        setErrors(prev => ({
          ...prev,
          numero_ordem: validateNumeroOrdemOnda(newValue)
            ? ''
            : 'Número da ordem inválido. Use 10 números + 1 letra (ex: 7843221527A)'
        }));
      } else {
        setErrors(prev => ({ ...prev, numero_ordem: '' }));
      }
    }

    setFormData(prev => ({
      ...prev,
      [name]: newValue
    }));

    // Limpar erro do campo (documento, cpf, PAP e ordem já tratam o próprio erro)
    if (errors[name] && name !== 'documento' && name !== 'cpf' && name !== 'vendedor_codigo_pap' && name !== 'numero_ordem') {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handlePlanoChange = (planoId) => {
    if (planoId === PLANO_MANUAL_ID) {
      setPlanoSelecionadoId(PLANO_MANUAL_ID);
      setPlanoManualForm({ texto: formData.observacao_venda || '', valor: formData.valor_total || '' });
      setShowPlanoManualModal(true);
      if (errors.plano) setErrors(prev => ({ ...prev, plano: '' }));
      return;
    }

    const id = planoId ? parseInt(planoId, 10) : null;
    setPlanoSelecionadoId(id);

    if (errors.plano) setErrors(prev => ({ ...prev, plano: '' }));

    if (id) {
      const plano = planosList.find(p => p.id === id);
      if (plano) {
        const valorFormatado = maskMoney(String(Number(plano.valor).toFixed(2)));
        setFormData(prev => ({
          ...prev,
          valor_total: valorFormatado
        }));
      }
    } else {
      setFormData(prev => ({
        ...prev,
        valor_total: '',
        ...(prev.observacao_venda && planoSelecionadoId === PLANO_MANUAL_ID ? { observacao_venda: '' } : {})
      }));
    }
  };

  const confirmarPlanoManual = () => {
    const texto = (planoManualForm.texto || '').trim();
    const valorStr = planoManualForm.valor ? unmaskMoney(String(planoManualForm.valor)) : '';
    const valorNum = valorStr ? Number(valorStr) : 0;
    if (!texto) {
      alert('Informe a descrição do plano.');
      return;
    }
    if (!valorStr || isNaN(valorNum) || valorNum <= 0) {
      alert('Informe um valor válido.');
      return;
    }
    setFormData(prev => ({
      ...prev,
      observacao_venda: texto,
      valor_total: maskMoney(String(valorNum.toFixed(2)))
    }));
    setShowPlanoManualModal(false);
    setPlanoManualForm({ texto: '', valor: '' });
  };

  const cancelarPlanoManual = () => {
    setPlanoSelecionadoId(null);
    setShowPlanoManualModal(false);
    setPlanoManualForm({ texto: '', valor: '' });
  };

  const handleTipoClienteChange = (tipo) => {
    setFormData(prev => ({
      ...prev,
      tipo_cliente: tipo,
      documento: '',
      complemento1: '',
      complemento2: '',
      complemento3: '',
      marca: tipo === 'cpf' ? prev.marca : '',
      numero_ordem: '',
      data_instalacao: '',
      // Limpar campos específicos do CNPJ quando mudar para CPF
      ...(tipo === 'cpf' ? {
        razao_social: '',
        estado_cnpj: '',
        telefone2: '',
        email: '',
        cpf: '',
        nome_representante: '',
        rg: '',
        nome_mae: '',
        data_nascimento: ''
      } : {
        // Limpar campos específicos do CPF quando mudar para CNPJ
        nome_cliente: '',
        marca: '',
        vendedor_codigo_pap: '',
        vendedor_login_pap: '',
        numero_ordem: '',
        data_instalacao: ''
      })
    }));
    setComplementosCnpj([{ tipo: '', valor: '' }]);
    if (tipo === 'cnpj' && envioAceiteSelecionado === 'whatsapp') {
      setEnvioAceiteSelecionado('');
    } else if (tipo === 'cpf' && operadoraSelecionada) {
      setEnvioAceiteSelecionado(getEnvioAceitePadrao(operadoraSelecionada, 'cpf'));
    }
    setErrors(prev => ({ ...prev, documento: '', marca: '', numero_ordem: '', data_instalacao: '' }));
  };

  const handleMarcaChange = (marca) => {
    setFormData(prev => ({
      ...prev,
      marca,
      // Limpar ordem e data de instalação se sair da ONDA/VISION
      ...(marcaExigeNumeroOrdem(marca) ? {} : { numero_ordem: '', data_instalacao: '' })
    }));
    setErrors(prev => ({ ...prev, marca: '', numero_ordem: '', data_instalacao: '' }));
  };

  const atualizarComplementoCnpj = (index, campo, valor) => {
    setComplementosCnpj(prev => prev.map((item, i) => (
      i === index ? { ...item, [campo]: valor } : item
    )));
  };

  const adicionarComplementoCnpj = () => {
    setComplementosCnpj(prev => (
      prev.length >= 3 ? prev : [...prev, { tipo: '', valor: '' }]
    ));
  };

  const removerComplementoCnpj = (index) => {
    setComplementosCnpj(prev => {
      if (prev.length <= 1) return [{ tipo: '', valor: '' }];
      return prev.filter((_, i) => i !== index);
    });
  };

  useEffect(() => {
    if (!operadoraSelecionada) return;
    const meios = getMeiosEnvioAceite(operadoraSelecionada, formData.tipo_cliente);
    if (envioAceiteSelecionado && !meios.includes(envioAceiteSelecionado)) {
      setEnvioAceiteSelecionado(getEnvioAceitePadrao(operadoraSelecionada, formData.tipo_cliente));
      return;
    }
    if (!envioAceiteSelecionado && formData.tipo_cliente === 'cpf' && meios.includes('whatsapp')) {
      setEnvioAceiteSelecionado('whatsapp');
    }
  }, [formData.tipo_cliente, operadoraSelecionada, envioAceiteSelecionado]);

  const buscarCep = async () => {
    const cepLimpo = formData.cep.replace(/\D/g, '');
    
    if (cepLimpo.length !== 8) {
      setErrors(prev => ({ ...prev, cep: 'CEP inválido' }));
      return;
    }

    try {
      setBuscandoCep(true);
      const data = await viaCepService.buscarCep(cepLimpo);
      
      setFormData(prev => ({
        ...prev,
        logradouro: data.logradouro || '',
        bairro: data.bairro || '',
        cidade: data.localidade || '',
        estado: data.uf || '',
        estado_completo: data.estado || ''
      }));
      
      setErrors(prev => ({ ...prev, cep: '' }));
    } catch (error) {
      setErrors(prev => ({ ...prev, cep: 'CEP não encontrado' }));
    } finally {
      setBuscandoCep(false);
    }
  };

  const preencherDadosCnpj = async (cnpjLimpo, razaoSocialInicial = '') => {
    const data = await salesService.buscarCnpj(cnpjLimpo);
    const razaoSocial = data.nome || razaoSocialInicial || '';
    setFormData(prev => ({
      ...prev,
      nome_cliente: razaoSocial,
      razao_social: razaoSocial,
      estado_cnpj: data.situacao || '',
    }));
    setErrors(prev => ({ ...prev, documento: '' }));
    return data;
  };

  const buscarCnpj = async () => {
    const cnpjLimpo = formData.documento.replace(/\D/g, '');
    
    if (cnpjLimpo.length !== 14) {
      setErrors(prev => ({ ...prev, documento: 'CNPJ inválido' }));
      return;
    }

    if (!validateCNPJ(formData.documento)) {
      setErrors(prev => ({ ...prev, documento: 'CNPJ inválido' }));
      return;
    }

    try {
      setBuscandoCnpj(true);
      await preencherDadosCnpj(cnpjLimpo);
      alert('✅ CNPJ encontrado! Razão Social preenchida automaticamente.');
    } catch (error) {
      console.error('Erro ao buscar CNPJ:', error);
      setErrors(prev => ({ ...prev, documento: error.response?.data?.error || 'CNPJ não encontrado ou inválido' }));
    } finally {
      setBuscandoCnpj(false);
    }
  };


  const validateForm = () => {
    const newErrors = {};

    // Validação de documento
    if (!formData.documento) {
      newErrors.documento = 'Documento é obrigatório';
    } else if (formData.tipo_cliente === 'cpf' && !validateCPF(formData.documento)) {
      newErrors.documento = 'CPF inválido';
    } else if (formData.tipo_cliente === 'cnpj' && !validateCNPJ(formData.documento)) {
      newErrors.documento = 'CNPJ inválido';
    }

    // Validação de plano quando operadora tem planos habilitados (CNPJ)
    if (formData.tipo_cliente === 'cnpj' && operadoraObj?.planos_habilitados && planosList.length > 0) {
      if (!planoSelecionadoId) {
        newErrors.plano = 'Selecione um plano cadastrado';
      }
    }

    if (formData.tipo_cliente === 'cpf') {
      if (produtosSelecionados.length === 0) {
        newErrors.produtos_pf = 'Selecione ao menos um produto PF do catálogo';
      }
    }

    // Validação de envio de aceite quando operadora estiver selecionada e for uma das permitidas
    if (operadoraRequerEnvioAceite() && !envioAceiteSelecionado) {
      newErrors.envio_aceite = 'Selecione um meio de envio de aceite para esta operadora';
    }

    // Validações obrigatórias
    const requiredFields = {
      telefone: 'Telefone',
      cep: 'CEP',
      logradouro: 'Logradouro',
      bairro: 'Bairro',
      cidade: 'Cidade',
      estado: 'Estado',
      estado_completo: 'Estado completo',
      numero: 'Número',
      data_agendamento1: 'Data de agendamento 1',
      valor_total: 'Valor total'
    };

    // Validação de nome_cliente ou razao_social
    if (formData.tipo_cliente === 'cpf') {
      if (!formData.nome_cliente) {
        newErrors.nome_cliente = 'Nome do cliente é obrigatório';
      }
    }

    // Validação de email (obrigatório para ambos)
    if (!formData.email) {
      newErrors.email = 'Email é obrigatório';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Email inválido';
    }

    // Validações específicas para CPF
    if (formData.tipo_cliente === 'cpf') {
      if (!formData.marca || !isMarcaValida(formData.marca)) {
        newErrors.marca = 'Selecione a marca da venda CPF';
      } else if (!vendedorPodeVenderMarca(formData.marca)) {
        newErrors.marca = `Você só pode cadastrar vendas CPF na marca ${formatMarcasPermitidasErro(vendedorMarcasPermitidas)}`;
      }
      if (!formData.nome_mae) {
        newErrors.nome_mae = 'Nome da mãe é obrigatório';
      }
      if (!formData.data_nascimento) {
        newErrors.data_nascimento = 'Data de nascimento é obrigatória';
      }
      // Validação PAP quando vendedor tem PAP da marca selecionada
      if (exigeCamposPap) {
        if (!formData.vendedor_codigo_pap || formData.vendedor_codigo_pap.trim() === '') {
          newErrors.vendedor_codigo_pap = 'Código PAP é obrigatório';
        } else if (!validateCodigoPap(formData.vendedor_codigo_pap)) {
          newErrors.vendedor_codigo_pap = 'Código PAP inválido. Use o formato XX-###### ou XX-####### (ex: SC-339683)';
        }
        if (!formData.vendedor_login_pap || formData.vendedor_login_pap.trim() === '') {
          newErrors.vendedor_login_pap = 'Login PAP é obrigatório';
        }
        if (marcaExigeNumeroOrdem(formData.marca)) {
          const ordemNorm = normalizeNumeroOrdemOnda(formData.numero_ordem);
          if (!ordemNorm) {
            newErrors.numero_ordem = `Número da ordem é obrigatório para vendas ${formatMarcaLabel(formData.marca)}`;
          } else if (!validateNumeroOrdemOnda(ordemNorm)) {
            newErrors.numero_ordem = 'Número da ordem inválido. Use 10 números + 1 letra (ex: 7843221527A)';
          }
          if (!formData.data_instalacao) {
            newErrors.data_instalacao = `Data da instalação é obrigatória para vendas ${formatMarcaLabel(formData.marca)}`;
          }
        }
      }
    }

    // Validações específicas para CNPJ
    if (formData.tipo_cliente === 'cnpj') {
      if (!formData.razao_social) {
        newErrors.razao_social = 'Razão Social é obrigatória';
      }
      if (!formData.estado_cnpj) {
        newErrors.estado_cnpj = 'Estado do CNPJ é obrigatório';
      }
      if (!formData.cpf) {
        newErrors.cpf = 'CPF é obrigatório';
      } else if (!validateCPF(formData.cpf)) {
        newErrors.cpf = 'CPF inválido';
      }
      if (!formData.nome_representante) {
        newErrors.nome_representante = 'Nome do representante é obrigatório';
      }
      if (!formData.rg) {
        newErrors.rg = 'RG é obrigatório';
      }
      if (!formData.nome_mae) {
        newErrors.nome_mae = 'Nome da mãe é obrigatório';
      }
      if (!formData.data_nascimento) {
        newErrors.data_nascimento = 'Data de nascimento é obrigatória';
      }
    }

    Object.entries(requiredFields).forEach(([field, label]) => {
      if (!formData[field]) {
        newErrors[field] = `${label} é obrigatório`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      alert('Por favor, preencha todos os campos obrigatórios corretamente');
      return;
    }

    if (formData.tipo_cliente !== 'cpf') {
      setShowResumoModal(true);
      return;
    }

    try {
      setConsultandoEmpresas(true);
      const resultado = await apiConfigService.consultarEmpresasCpf({
        nome: formData.nome_cliente,
        telefone: formData.telefone.replace(/\D/g, ''),
        cpf: normalizeCpf(formData.documento)
      });

      const empresas = resultado?.empresas || [];
      if (resultado?.sucesso && empresas.length > 0) {
        setEmpresasDisponiveis(empresas);
        setCnpjSelecionado(empresas.length === 1 ? empresas[0].cnpj : '');
        setEtapaCnpjModal('escolha');
        setShowCnpjDisponivelModal(true);
      } else {
        setCpfTinhaCnpjDisponivel(false);
        setShowResumoModal(true);
      }
    } catch (error) {
      console.error('Erro ao consultar empresas por CPF:', error);
      setCpfTinhaCnpjDisponivel(false);
      setShowResumoModal(true);
    } finally {
      setConsultandoEmpresas(false);
    }
  };

  const handleContinuarComoCpf = () => {
    setCpfTinhaCnpjDisponivel(true);
    setShowCnpjDisponivelModal(false);
    setShowResumoModal(true);
  };

  const handleIrParaSelecaoCnpj = async () => {
    if (empresasDisponiveis.length === 1) {
      await aplicarCnpjSelecionado(empresasDisponiveis[0]);
      return;
    }
    if (!cnpjSelecionado && empresasDisponiveis.length > 0) {
      setCnpjSelecionado(empresasDisponiveis[0].cnpj);
    }
    setEtapaCnpjModal('selecionar');
  };

  const abrirResumoOuRg = (rgAtual) => {
    if (!rgAtual || !String(rgAtual).trim()) {
      setRgTemp('');
      setShowRgModal(true);
    } else {
      setShowResumoModal(true);
    }
  };

  const aplicarCnpjSelecionado = async (empresa) => {
    const cpfOriginal = normalizeCpf(formData.documento);
    const nomeOriginal = formData.nome_cliente;
    const cnpjLimpo = String(empresa.cnpj || '').replace(/\D/g, '');

    setCpfTinhaCnpjDisponivel(false);

    const meiosCnpj = getMeiosEnvioAceite(operadoraSelecionada, 'cnpj');
    if (envioAceiteSelecionado && !meiosCnpj.includes(envioAceiteSelecionado)) {
      setEnvioAceiteSelecionado('');
    }

    setFormData(prev => ({
      ...prev,
      tipo_cliente: 'cnpj',
      documento: maskCNPJ(cnpjLimpo),
      cpf: maskCPF(cpfOriginal),
      nome_representante: nomeOriginal,
      razao_social: empresa.razao_social || '',
      nome_cliente: empresa.razao_social || '',
      complemento1: '',
      complemento2: '',
      complemento3: ''
    }));
    setComplementosCnpj([{ tipo: '', valor: '' }]);

    try {
      setBuscandoCnpj(true);
      await preencherDadosCnpj(cnpjLimpo, empresa.razao_social || '');
    } catch (error) {
      console.error('Erro ao buscar CNPJ na conversão:', error);
    } finally {
      setBuscandoCnpj(false);
    }

    setShowCnpjDisponivelModal(false);
    abrirResumoOuRg(formData.rg);
  };

  const handleConfirmarCnpjSelecionado = async () => {
    const cnpjEscolhido = cnpjSelecionado || empresasDisponiveis[0]?.cnpj;
    const empresa = empresasDisponiveis.find((e) => e.cnpj === cnpjEscolhido);
    if (!empresa) {
      alert('Selecione um CNPJ para continuar');
      return;
    }
    await aplicarCnpjSelecionado(empresa);
  };

  const handleConfirmarRg = () => {
    if (!rgTemp.trim()) {
      alert('Informe o RG do representante para continuar');
      return;
    }
    setFormData(prev => ({ ...prev, rg: rgTemp.trim() }));
    setShowRgModal(false);
    setShowResumoModal(true);
  };

  // Função para formatar período para exibição
  const formatarPeriodo = (periodo) => {
    const periodos = {
      'manha': 'Manhã',
      'tarde': 'Tarde',
      'noite': 'Noite'
    };
    return periodos[periodo] || periodo;
  };

  // Função para formatar data para exibição
  const formatarData = (data) => {
    if (!data) return '-';
    const [ano, mes, dia] = data.split('-');
    return `${dia}/${mes}/${ano}`;
  };

  // Função para confirmar e enviar a venda
  const confirmarEnvioVenda = async () => {
    try {
      setLoading(true);

      // Construir observação final
      let observacaoFinal = formData.observacao_venda || '';
      if (formData.tipo_cliente === 'cpf' && produtosSelecionados.length > 0) {
        const nomesProdutos = produtosSelecionados.map(p => p.nome_neo).join(' + ');
        observacaoFinal = observacaoFinal ? `${nomesProdutos}. ${observacaoFinal}` : nomesProdutos;
      } else if (planoSelecionadoId && planoSelecionadoId !== PLANO_MANUAL_ID) {
        const plano = planosList.find(p => p.id === planoSelecionadoId);
        if (plano) {
          observacaoFinal = observacaoFinal ? `${plano.nome}. ${observacaoFinal}` : plano.nome;
        }
      }

      const produtosJson = formData.tipo_cliente === 'cpf' && produtosSelecionados.length > 0
        ? JSON.stringify(produtosSelecionados.map(p => ({
          catalogo_plano_id: p.catalogo_plano_id,
          nome_neo: p.nome_neo,
          filtro_busca: p.filtro_busca || null,
          valor_negociado: parseFloat(p.valor_negociado) || 0,
          quantidade: parseInt(p.quantidade, 10) || 1
        })))
        : null;

      const valorTotalProdutos = produtosSelecionados.reduce((acc, p) => {
        const v = parseFloat(String(p.valor_negociado).replace(',', '.')) || 0;
        const q = parseInt(p.quantidade, 10) || 1;
        return acc + v * q;
      }, 0);

      const valorTotalEnvio = formData.tipo_cliente === 'cpf' && produtosSelecionados.length > 0
        ? valorTotalProdutos.toFixed(2)
        : unmaskMoney(formData.valor_total);

      const complementosSerializados = formData.tipo_cliente === 'cnpj'
        ? serializarComplementosCnpj(complementosCnpj)
        : {
            complemento1: formData.complemento1 || '',
            complemento2: formData.complemento2 || '',
            complemento3: ''
          };

      // Preparar dados da venda
      const saleData = {
        ...formData,
        ...complementosSerializados,
        documento: formData.tipo_cliente === 'cpf'
          ? normalizeCpf(formData.documento)
          : formData.documento.replace(/\D/g, ''),
        nome_cliente: formData.tipo_cliente === 'cnpj' ? formData.razao_social : formData.nome_cliente,
        telefone: formData.telefone.replace(/\D/g, ''),
        telefone2: formData.telefone2 ? formData.telefone2.replace(/\D/g, '') : null,
        cpf: formData.cpf ? normalizeCpf(formData.cpf) : null,
        cep: formData.cep.replace(/\D/g, ''),
        valor_total: valorTotalEnvio,
        data_agendamento2: formData.data_agendamento2 || null,
        periodo_agendamento2: formData.periodo_agendamento2 || null,
        data_nascimento: formData.data_nascimento || null,
        operadora_selecionada: operadoraSelecionada || null,
        operadora_viabilidade_json: operadoraViabilidadeJson ? JSON.stringify(operadoraViabilidadeJson) : null,
        envio_aceite: operadoraSelecionada && envioAceiteSelecionado
          ? `${operadoraSelecionada}:${envioAceiteSelecionado}`
          : null,
        observacao_venda: observacaoFinal,
        produtos_selecionados_json: produtosJson,
        marca: formData.tipo_cliente === 'cpf' ? formData.marca : null,
        numero_ordem: formData.tipo_cliente === 'cpf' && marcaExigeNumeroOrdem(formData.marca) && formData.numero_ordem
          ? normalizeNumeroOrdemOnda(formData.numero_ordem)
          : null,
        data_instalacao: exigeCamposPap && marcaExigeNumeroOrdem(formData.marca) && formData.data_instalacao
          ? formData.data_instalacao
          : null
      };

      if (cpfTinhaCnpjDisponivel) {
        saleData.cpf_tinha_cnpj_disponivel = true;
        saleData.cnpjs_disponiveis = JSON.stringify(empresasDisponiveis);
      }

      if (user?.role === 'supervisor' && vendedorId != null) {
        saleData.vendedor_id = vendedorId;
      }

      // Se houver arquivos anexos, usar FormData
      if (documentosAnexos.length > 0) {
        const formDataToSend = new FormData();
        
        // Adicionar todos os campos como string
        Object.keys(saleData).forEach(key => {
          const value = saleData[key];
          if (value !== null && value !== undefined) {
            if (typeof value === 'object') {
              formDataToSend.append(key, JSON.stringify(value));
            } else if (typeof value === 'boolean') {
              formDataToSend.append(key, value.toString());
            } else {
              formDataToSend.append(key, value);
            }
          }
        });
        
        // Adicionar todos os arquivos
        documentosAnexos.forEach((file) => {
          formDataToSend.append('documento_anexo', file);
        });
        
        await salesService.create(formDataToSend, true); // true indica FormData
      } else {
        await salesService.create(saleData);
      }
      
      alert('✅ Venda cadastrada com sucesso!');
      navigate('/vendas');
    } catch (error) {
      console.error('Erro ao criar venda:', error);
      alert('❌ Erro ao cadastrar venda: ' + (error.response?.data?.error || 'Erro desconhecido'));
    } finally {
      setLoading(false);
      setShowResumoModal(false);
    }
  };

  return (
    <Layout>
      <div className="nova-venda-page">
        <div className="page-header">
          <h1>➕ Nova Venda</h1>
          <p>Cadastre uma nova venda no sistema</p>
        </div>

        <form onSubmit={handleSubmit} className="venda-form">
          {/* Operadora Selecionada (se vier da consulta de viabilidade) */}
          {operadoraSelecionada && (
            <>
              <div className="form-section operadora-info">
                <h2>📡 Operadora Selecionada</h2>
                <div className="operadora-selecionada-info">
                  <strong>{operadoraSelecionada.charAt(0).toUpperCase() + operadoraSelecionada.slice(1)}</strong>
                  <span className="info-text">Operadora selecionada na consulta de viabilidade</span>
                </div>
              </div>

              {/* Seção de Envio de Aceite - apenas se operadora estiver selecionada */}
              <div className="form-section">
                <h2>📧 Envio de Aceite</h2>
                <p className="section-subtitle">
                  Selecione o meio de envio de aceite para <strong>{operadoraSelecionada.charAt(0).toUpperCase() + operadoraSelecionada.slice(1)}</strong>
                </p>
                <div className="form-group">
                  <div
                    className={`envio-aceite-opcoes${errors.envio_aceite ? ' error' : ''}`}
                    style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}
                  >
                    {getMeiosEnvioAceite(operadoraSelecionada, formData.tipo_cliente).map((meio) => {
                      const selecionado = envioAceiteSelecionado === meio;
                      const corTexto = selecionado ? 'white' : 'var(--texto-primario)';
                      const waIconColor = selecionado ? '#fff' : '#25D366';
                      return (
                        <label
                          key={meio}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            padding: '1rem',
                            background: selecionado ? 'var(--azul-dvs)' : 'var(--cinza-escuro-2)',
                            border: `2px solid ${selecionado ? 'var(--azul-dvs)' : 'var(--border-color)'}`,
                            borderRadius: '8px',
                            cursor: 'pointer',
                            color: corTexto,
                            flex: '1 1 120px',
                            justifyContent: 'center',
                            transition: 'all 0.2s ease',
                          }}
                        >
                          <input
                            type="radio"
                            name="envioAceite"
                            value={meio}
                            checked={selecionado}
                            onChange={(e) => setEnvioAceiteSelecionado(e.target.value)}
                            style={{ display: 'none' }}
                          />
                          {meio === 'whatsapp' ? (
                            <>
                              <WhatsAppIcon size={22} color={waIconColor} />
                              <span style={{ fontWeight: 600 }}>WhatsApp</span>
                            </>
                          ) : meio === 'sms' ? (
                            <>
                              <span style={{ fontSize: '1.25rem' }} aria-hidden>📱</span>
                              <span style={{ fontWeight: 600 }}>SMS</span>
                            </>
                          ) : (
                            <>
                              <span style={{ fontSize: '1.25rem' }} aria-hidden>📧</span>
                              <span style={{ fontWeight: 600 }}>E-mail</span>
                            </>
                          )}
                        </label>
                      );
                    })}
                  </div>
                </div>
                {errors.envio_aceite && (
                  <span className="error-text" style={{ marginTop: '0.5rem' }}>
                    {errors.envio_aceite}
                  </span>
                )}
              </div>
            </>
          )}

          {/* Registrar venda para (apenas supervisor) */}
          {user?.role === 'supervisor' && opcoesVendedor.length > 0 && (
            <div className="form-section">
              <h2>👤 Registrar venda para</h2>
              <div className="form-group">
                <label htmlFor="vendedor-select">Vendedor</label>
                <select
                  id="vendedor-select"
                  value={vendedorId ?? ''}
                  onChange={(e) => setVendedorId(parseInt(e.target.value, 10))}
                >
                  {opcoesVendedor.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {/* Tipo de Cliente */}
          <div className="form-section">
            <h2>👤 Tipo de Cliente</h2>
            <div className="tipo-cliente-buttons">
              <button
                type="button"
                className={`tipo-btn ${formData.tipo_cliente === 'cpf' ? 'active' : ''}`}
                onClick={() => handleTipoClienteChange('cpf')}
              >
                👤 Pessoa Física (CPF)
              </button>
              <button
                type="button"
                className={`tipo-btn ${formData.tipo_cliente === 'cnpj' ? 'active' : ''}`}
                onClick={() => handleTipoClienteChange('cnpj')}
              >
                🏢 Pessoa Jurídica (CNPJ)
              </button>
            </div>
          </div>

          {/* Marca — obrigatório em CPF */}
          {formData.tipo_cliente === 'cpf' && (
            <div className="form-section">
              <h2>🏷️ Marca</h2>
              <p className="section-subtitle">
                {marcasDisponiveis.length > 1
                  ? 'Selecione a marca da venda CPF *'
                  : `Vendas CPF restritas à marca ${formatMarcaLabel(marcasDisponiveis[0]?.id)} *`}
              </p>
              <div className="tipo-cliente-buttons">
                {marcasDisponiveis.map((marca) => (
                  <button
                    key={marca.id}
                    type="button"
                    className={`tipo-btn ${formData.marca === marca.id ? 'active' : ''}`}
                    onClick={() => handleMarcaChange(marca.id)}
                  >
                    {marca.label}
                  </button>
                ))}
              </div>
              {errors.marca && <span className="error-text">{errors.marca}</span>}
            </div>
          )}

          {/* Dados do Cliente */}
          <div className="form-section">
            <h2>👤 Dados do Cliente</h2>
            <div className="form-grid">
              <div className="form-group">
                <label>
                  {formData.tipo_cliente === 'cpf' ? 'CPF' : 'CNPJ'} *
                </label>
                {formData.tipo_cliente === 'cnpj' ? (
                  <div className="cep-input-wrapper">
                    <input
                      type="text"
                      name="documento"
                      value={formData.documento}
                      onChange={handleChange}
                      placeholder="00.000.000/0000-00"
                      className={errors.documento ? 'error' : ''}
                    />
                    <button
                      type="button"
                      onClick={buscarCnpj}
                      className="btn-buscar-cep"
                      disabled={buscandoCnpj}
                    >
                      {buscandoCnpj ? '⏳' : '🔍'} Buscar
                    </button>
                  </div>
                ) : (
                  <input
                    type="text"
                    name="documento"
                    value={formData.documento}
                    onChange={handleChange}
                    placeholder="000.000.000-00"
                    className={errors.documento ? 'error' : ''}
                  />
                )}
                {errors.documento && <span className="error-text">{errors.documento}</span>}
                {formData.tipo_cliente === 'cpf' && formData.documento.replace(/\D/g, '').length === 11 && !errors.documento && (
                  <span className="success-text" style={{ color: '#28a745', fontSize: '0.875rem', marginTop: '0.25rem' }}>
                    {buscandoCpf ? '⏳ Buscando dados...' : '✅ CPF válido'}
                  </span>
                )}
              </div>

              {formData.tipo_cliente === 'cnpj' ? (
                <>
                  <div className="form-group">
                    <label>Razão Social * <span className="auto-fill-badge">Preenchido automaticamente</span></label>
                    <textarea
                      name="razao_social"
                      value={formData.razao_social}
                      onChange={handleChange}
                      placeholder="Preenchido automaticamente"
                      className={`readonly-input ${errors.razao_social ? 'error' : ''}`}
                      readOnly
                      rows={2}
                      title={formData.razao_social}
                    />
                    {errors.razao_social && <span className="error-text">{errors.razao_social}</span>}
                  </div>

                  <div className="form-group">
                    <label>Estado do CNPJ * <span className="auto-fill-badge">Preenchido automaticamente</span></label>
                    <input
                      type="text"
                      name="estado_cnpj"
                      value={formData.estado_cnpj}
                      onChange={handleChange}
                      placeholder="Preenchido automaticamente"
                      className={`readonly-input ${errors.estado_cnpj ? 'error' : ''}`}
                      readOnly
                    />
                    {errors.estado_cnpj && <span className="error-text">{errors.estado_cnpj}</span>}
                  </div>

                  <div className="form-group">
                    <label>CPF *</label>
                    <input
                      type="text"
                      name="cpf"
                      value={formData.cpf}
                      onChange={handleChange}
                      placeholder="000.000.000-00"
                      className={errors.cpf ? 'error' : ''}
                    />
                    {errors.cpf && <span className="error-text">{errors.cpf}</span>}
                  </div>

                  <div className="form-group">
                    <label>Nome do Representante *</label>
                    <input
                      type="text"
                      name="nome_representante"
                      value={formData.nome_representante}
                      onChange={handleChange}
                      placeholder="Nome completo do representante legal"
                      className={errors.nome_representante ? 'error' : ''}
                      disabled={buscandoCpf}
                    />
                    {errors.nome_representante && <span className="error-text">{errors.nome_representante}</span>}
                  </div>

                  <div className="form-group">
                    <label>RG</label>
                    <input
                      type="text"
                      name="rg"
                      value={formData.rg}
                      onChange={handleChange}
                      placeholder="00.000.000-0"
                      className={errors.rg ? 'error' : ''}
                    />
                    {errors.rg && <span className="error-text">{errors.rg}</span>}
                  </div>

                  <div className="form-group">
                    <label>Nome da Mãe *</label>
                    <input
                      type="text"
                      name="nome_mae"
                      value={formData.nome_mae}
                      onChange={handleChange}
                      placeholder="Nome completo da mãe"
                      className={errors.nome_mae ? 'error' : ''}
                      disabled={buscandoCpf}
                    />
                    {errors.nome_mae && <span className="error-text">{errors.nome_mae}</span>}
                  </div>

                  <div className="form-group">
                    <label>Data de Nascimento *</label>
                    <input
                      type="date"
                      name="data_nascimento"
                      value={formData.data_nascimento}
                      onChange={handleChange}
                      className={errors.data_nascimento ? 'error' : ''}
                      disabled={buscandoCpf}
                    />
                    {errors.data_nascimento && <span className="error-text">{errors.data_nascimento}</span>}
                  </div>
                </>
              ) : (
                <>
                  <div className="form-group">
                    <label>Nome Completo *</label>
                    <input
                      type="text"
                      name="nome_cliente"
                      value={formData.nome_cliente}
                      onChange={handleChange}
                      placeholder="Nome completo do cliente"
                      className={errors.nome_cliente ? 'error' : ''}
                      disabled={buscandoCpf}
                    />
                    {errors.nome_cliente && <span className="error-text">{errors.nome_cliente}</span>}
                  </div>

                  <div className="form-group">
                    <label>RG</label>
                    <input
                      type="text"
                      name="rg"
                      value={formData.rg}
                      onChange={handleChange}
                      placeholder="00.000.000-0"
                      className={errors.rg ? 'error' : ''}
                    />
                    {errors.rg && <span className="error-text">{errors.rg}</span>}
                  </div>

                  <div className="form-group">
                    <label>Nome da Mãe *</label>
                    <input
                      type="text"
                      name="nome_mae"
                      value={formData.nome_mae}
                      onChange={handleChange}
                      placeholder="Nome completo da mãe"
                      className={errors.nome_mae ? 'error' : ''}
                      disabled={buscandoCpf}
                    />
                    {errors.nome_mae && <span className="error-text">{errors.nome_mae}</span>}
                  </div>

                  <div className="form-group">
                    <label>Data de Nascimento *</label>
                    <input
                      type="date"
                      name="data_nascimento"
                      value={formData.data_nascimento}
                      onChange={handleChange}
                      className={errors.data_nascimento ? 'error' : ''}
                      disabled={buscandoCpf}
                    />
                    {errors.data_nascimento && <span className="error-text">{errors.data_nascimento}</span>}
                  </div>
                </>
              )}

              <div className="form-group">
                <label>Telefone 1 *</label>
                <input
                  type="text"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  placeholder="(00) 00000-0000"
                  className={errors.telefone ? 'error' : ''}
                  disabled={buscandoCpf}
                />
                {errors.telefone && <span className="error-text">{errors.telefone}</span>}
              </div>

              <div className="form-group">
                <label>Telefone 2</label>
                <input
                  type="text"
                  name="telefone2"
                  value={formData.telefone2}
                  onChange={handleChange}
                  placeholder="(00) 00000-0000"
                  className={errors.telefone2 ? 'error' : ''}
                />
                {errors.telefone2 && <span className="error-text">{errors.telefone2}</span>}
              </div>

              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="email@exemplo.com"
                  className={errors.email ? 'error' : ''}
                  disabled={buscandoCpf}
                />
                {errors.email && <span className="error-text">{errors.email}</span>}
              </div>
            </div>

            {/* Campos PAP - CPF quando vendedor tem PAP da marca */}
            {exigeCamposPap && (
              <div className="form-section">
                <h2>📋 Dados PAP ({formatMarcaLabel(formData.marca)})</h2>
                <p className="section-subtitle">
                  Você possui PAP nesta marca. Preencha os dados abaixo para esta venda CPF.
                </p>
                <div className="form-grid">
                  <div className="form-group">
                    <label>Código PAP *</label>
                    <input
                      type="text"
                      name="vendedor_codigo_pap"
                      value={formData.vendedor_codigo_pap}
                      onChange={handleChange}
                      placeholder="Ex: SC-339683"
                      maxLength={10}
                      className={errors.vendedor_codigo_pap ? 'error' : ''}
                    />
                    {errors.vendedor_codigo_pap && <span className="error-text">{errors.vendedor_codigo_pap}</span>}
                  </div>
                  <div className="form-group">
                    <label>Login PAP *</label>
                    <input
                      type="text"
                      name="vendedor_login_pap"
                      value={formData.vendedor_login_pap}
                      onChange={handleChange}
                      placeholder="Digite o login PAP"
                      className={errors.vendedor_login_pap ? 'error' : ''}
                    />
                    {errors.vendedor_login_pap && <span className="error-text">{errors.vendedor_login_pap}</span>}
                  </div>
                  {marcaExigeNumeroOrdem(formData.marca) && (
                    <div className="form-group">
                      <label>Número da Ordem *</label>
                      <input
                        type="text"
                        name="numero_ordem"
                        value={formData.numero_ordem}
                        onChange={handleChange}
                        placeholder="Ex: 7843221527A"
                        autoCapitalize="characters"
                        spellCheck={false}
                        className={errors.numero_ordem ? 'error' : ''}
                      />
                      {errors.numero_ordem && <span className="error-text">{errors.numero_ordem}</span>}
                    </div>
                  )}
                  {marcaExigeNumeroOrdem(formData.marca) && (
                    <div className="form-group">
                      <label>Data da Instalação *</label>
                      <input
                        type="date"
                        name="data_instalacao"
                        value={formData.data_instalacao}
                        onChange={handleChange}
                        className={errors.data_instalacao ? 'error' : ''}
                      />
                      {errors.data_instalacao && <span className="error-text">{errors.data_instalacao}</span>}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* Endereço */}
          <div className="form-section">
            <h2>📍 Endereço</h2>
            <div className="form-grid">
              <div className="form-group cep-group">
                <label>CEP *</label>
                <div className="cep-input-wrapper">
                  <input
                    type="text"
                    name="cep"
                    value={formData.cep}
                    onChange={handleChange}
                    placeholder="00000-000"
                    className={errors.cep ? 'error' : ''}
                  />
                  <button
                    type="button"
                    onClick={buscarCep}
                    className="btn-buscar-cep"
                    disabled={buscandoCep}
                  >
                    {buscandoCep ? '⏳' : '🔍'} Buscar
                  </button>
                </div>
                {errors.cep && <span className="error-text">{errors.cep}</span>}
              </div>

              <div className="form-group">
                <label>Logradouro *</label>
                <input
                  type="text"
                  name="logradouro"
                  value={formData.logradouro}
                  onChange={handleChange}
                  placeholder="Rua, Avenida, etc."
                  className={errors.logradouro ? 'error' : ''}
                />
                {errors.logradouro && <span className="error-text">{errors.logradouro}</span>}
              </div>

              <div className="form-group">
                <label>Número *</label>
                <input
                  type="text"
                  name="numero"
                  value={formData.numero}
                  onChange={handleChange}
                  placeholder="123"
                  className={errors.numero ? 'error' : ''}
                />
                {errors.numero && <span className="error-text">{errors.numero}</span>}
              </div>

              <div className="form-group">
                <label>Bairro *</label>
                <input
                  type="text"
                  name="bairro"
                  value={formData.bairro}
                  onChange={handleChange}
                  placeholder="Nome do bairro"
                  className={errors.bairro ? 'error' : ''}
                />
                {errors.bairro && <span className="error-text">{errors.bairro}</span>}
              </div>

              <div className="form-group">
                <label>Cidade *</label>
                <input
                  type="text"
                  name="cidade"
                  value={formData.cidade}
                  onChange={handleChange}
                  placeholder="Nome da cidade"
                  className={errors.cidade ? 'error' : ''}
                />
                {errors.cidade && <span className="error-text">{errors.cidade}</span>}
              </div>

              <div className="form-group">
                <label>Estado (UF) *</label>
                <input
                  type="text"
                  name="estado"
                  value={formData.estado}
                  onChange={handleChange}
                  placeholder="SP"
                  maxLength="2"
                  className={errors.estado ? 'error' : ''}
                />
                {errors.estado && <span className="error-text">{errors.estado}</span>}
              </div>

              <div className="form-group">
                <label>Estado Completo *</label>
                <input
                  type="text"
                  name="estado_completo"
                  value={formData.estado_completo}
                  onChange={handleChange}
                  placeholder="São Paulo"
                  className={errors.estado_completo ? 'error' : ''}
                />
                {errors.estado_completo && <span className="error-text">{errors.estado_completo}</span>}
              </div>

              {formData.tipo_cliente === 'cpf' ? (
                <>
                  <div className="form-group">
                    <label>Complemento 1 (opcional)</label>
                    <input
                      type="text"
                      name="complemento1"
                      value={formData.complemento1}
                      onChange={handleChange}
                      placeholder="Apto, Bloco, etc."
                    />
                  </div>

                  <div className="form-group">
                    <label>Complemento 2 (opcional)</label>
                    <input
                      type="text"
                      name="complemento2"
                      value={formData.complemento2}
                      onChange={handleChange}
                      placeholder="Ponto de referência"
                    />
                  </div>
                </>
              ) : (
                <div className="form-group" style={{ gridColumn: '1 / -1' }}>
                  <label>Complementos (opcional, até 3)</label>
                  {complementosCnpj.map((item, index) => (
                    <div
                      key={index}
                      className="complemento-cnpj-row"
                      style={{
                        display: 'flex',
                        gap: '0.5rem',
                        alignItems: 'center',
                        marginBottom: '0.5rem',
                        flexWrap: 'wrap'
                      }}
                    >
                      <select
                        value={item.tipo}
                        onChange={(e) => atualizarComplementoCnpj(index, 'tipo', e.target.value)}
                        style={{ flex: '1 1 160px', minWidth: '140px' }}
                      >
                        <option value="">Tipo...</option>
                        {TIPOS_COMPLEMENTO.map((tipo) => (
                          <option key={tipo} value={tipo}>{tipo}</option>
                        ))}
                      </select>
                      <input
                        type="text"
                        value={item.valor}
                        onChange={(e) => atualizarComplementoCnpj(index, 'valor', e.target.value)}
                        placeholder="Valor (ex.: 3)"
                        style={{ flex: '1 1 120px', minWidth: '100px' }}
                      />
                      {complementosCnpj.length > 1 && (
                        <button
                          type="button"
                          onClick={() => removerComplementoCnpj(index)}
                          className="btn-secondary"
                          style={{ padding: '0.4rem 0.75rem' }}
                          title="Remover complemento"
                        >
                          Remover
                        </button>
                      )}
                    </div>
                  ))}
                  {complementosCnpj.length < 3 && (
                    <button
                      type="button"
                      onClick={adicionarComplementoCnpj}
                      className="btn-secondary"
                      style={{ marginTop: '0.25rem' }}
                    >
                      + Adicionar complemento
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Agendamento de Instalação */}
          <div className="form-section">
            <h2>📅 Agendamento de Instalação</h2>
            <p className="section-subtitle">Marque a data e o período sugeridos pelo cliente para a instalação</p>
            
            <div className="agendamento-section">
              <h3>Opção 1 *</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>Data Sugerida *</label>
                  <input
                    type="date"
                    name="data_agendamento1"
                    value={formData.data_agendamento1}
                    onChange={handleChange}
                    className={errors.data_agendamento1 ? 'error' : ''}
                  />
                  {errors.data_agendamento1 && <span className="error-text">{errors.data_agendamento1}</span>}
                </div>

                <div className="form-group">
                  <label>Período *</label>
                  <select
                    name="periodo_agendamento1"
                    value={formData.periodo_agendamento1}
                    onChange={handleChange}
                  >
                    <option value="manha">Manhã</option>
                    <option value="tarde">Tarde</option>
                    <option value="noite">Noite</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="agendamento-section">
              <h3>Opção 2 (opcional)</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>Data Sugerida</label>
                  <input
                    type="date"
                    name="data_agendamento2"
                    value={formData.data_agendamento2}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Período</label>
                  <select
                    name="periodo_agendamento2"
                    value={formData.periodo_agendamento2}
                    onChange={handleChange}
                  >
                    <option value="">Selecione</option>
                    <option value="manha">Manhã</option>
                    <option value="tarde">Tarde</option>
                    <option value="noite">Noite</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="form-group checkbox-group">
              <label>
                <input
                  type="checkbox"
                  name="aceita_antecipacao"
                  checked={formData.aceita_antecipacao}
                  onChange={handleChange}
                />
                Cliente Aceita Antecipação
              </label>
            </div>

            <div className="form-group">
              <label>Observação sobre Instalação (opcional)</label>
              <textarea
                name="observacao_instalacao"
                value={formData.observacao_instalacao}
                onChange={handleChange}
                placeholder="Digite observações adicionais sobre a instalação..."
                rows="3"
              />
            </div>
          </div>

          {/* Produtos PF NEO (somente CPF) */}
          {formData.tipo_cliente === 'cpf' && (
            <div className="form-section">
              <h2>📦 Produtos PF (NEO)</h2>
              <p className="section-subtitle">Selecione um ou mais produtos do catálogo PF. O valor total será a soma dos itens.</p>
              {loadingProdutosPf ? (
                <p className="info-text">Carregando produtos...</p>
              ) : produtosPfCatalogo.length === 0 ? (
                <p className="info-text" style={{ color: '#ff9800' }}>Nenhum produto PF cadastrado no catálogo.</p>
              ) : (
                <>
                  <div className="form-group">
                    <label>Buscar produto</label>
                    <input
                      type="text"
                      value={buscaProdutoPf}
                      onChange={(e) => setBuscaProdutoPf(e.target.value)}
                      placeholder="Ex: 600 MEGA, VIVO PLAY..."
                      className={errors.produtos_pf ? 'error' : ''}
                    />
                    {buscaProdutoPf.trim() && produtosPfFiltrados.length > 0 && (
                      <div className="produtos-pf-sugestoes" style={{
                        marginTop: '0.5rem',
                        border: '1px solid var(--border-color, #444)',
                        borderRadius: '8px',
                        maxHeight: '200px',
                        overflowY: 'auto'
                      }}>
                        {produtosPfFiltrados.slice(0, 15).map(item => (
                          <button
                            key={item.id}
                            type="button"
                            onClick={() => adicionarProdutoPf(item)}
                            style={{
                              display: 'block',
                              width: '100%',
                              textAlign: 'left',
                              padding: '0.5rem 0.75rem',
                              border: 'none',
                              borderBottom: '1px solid var(--border-color, #333)',
                              background: 'transparent',
                              color: 'var(--texto-primario)',
                              cursor: 'pointer'
                            }}
                          >
                            {item.titulo || item.nome_neo}
                            {item.valor_padrao != null && (
                              <span style={{ marginLeft: '0.5rem', color: 'var(--texto-secundario)' }}>
                                — R$ {maskMoney(String(Number(item.valor_padrao).toFixed(2)))}
                              </span>
                            )}
                          </button>
                        ))}
                      </div>
                    )}
                    {errors.produtos_pf && <span className="error-text">{errors.produtos_pf}</span>}
                  </div>
                  {produtosSelecionados.length > 0 && (
                    <div className="produtos-pf-selecionados" style={{ marginTop: '1rem' }}>
                      <h3 style={{ fontSize: '1rem', marginBottom: '0.75rem' }}>Produtos selecionados</h3>
                      {produtosSelecionados.map((p) => (
                        <div key={p.catalogo_plano_id} style={{
                          display: 'grid',
                          gridTemplateColumns: '1fr 100px 100px auto',
                          gap: '0.5rem',
                          alignItems: 'center',
                          marginBottom: '0.5rem',
                          padding: '0.5rem',
                          background: 'rgba(0, 191, 255, 0.05)',
                          borderRadius: '8px'
                        }}>
                          <span style={{ fontSize: '0.85rem' }}>{p.nome_neo}</span>
                          <input
                            type="number"
                            min="1"
                            value={p.quantidade}
                            onChange={(e) => atualizarProdutoPf(p.catalogo_plano_id, 'quantidade', e.target.value)}
                            title="Quantidade"
                          />
                          <input
                            type="text"
                            value={maskMoney(String(Number(p.valor_negociado).toFixed(2)))}
                            onChange={(e) => atualizarProdutoPf(p.catalogo_plano_id, 'valor_negociado', e.target.value)}
                            title="Valor negociado"
                          />
                          <button
                            type="button"
                            className="btn-secondary btn-sm"
                            onClick={() => removerProdutoPf(p.catalogo_plano_id)}
                          >
                            Remover
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </>
              )}
            </div>
          )}

          {/* Plano (quando operadora tem planos ativados — CNPJ) */}
          {formData.tipo_cliente === 'cnpj' && operadoraObj?.planos_habilitados && planosList.length > 0 && (
            <div className="form-section">
              <h2>📋 Plano</h2>
              <p className="section-subtitle">Escolha o plano cadastrado para preencher o valor automaticamente</p>
              <div className="form-group">
                <label htmlFor="plano-select">Plano *</label>
                <select
                  id="plano-select"
                  value={planoSelecionadoId ?? ''}
                  onChange={(e) => handlePlanoChange(e.target.value)}
                  className={errors.plano ? 'error' : ''}
                >
                  <option value="">Selecione o plano</option>
                  {planosList.map((plano) => (
                    <option key={plano.id} value={plano.id}>
                      {plano.nome} - R$ {maskMoney(String(Number(plano.valor).toFixed(2)))}
                    </option>
                  ))}
                  <option value={PLANO_MANUAL_ID}>Plano manual (informar descrição e valor)</option>
                </select>
                {errors.plano && <span className="error-text">{errors.plano}</span>}
              </div>
            </div>
          )}

          {/* Dados Financeiros */}
          <div className="form-section">
            <h2>💰 Informações Financeiras</h2>
            <div className="form-grid">
              <div className="form-group">
                <label>Data de Vencimento *</label>
                <select
                  name="data_vencimento"
                  value={formData.data_vencimento}
                  onChange={handleChange}
                >
                  <option value={2}>Dia 2</option>
                  <option value={5}>Dia 5</option>
                  <option value={8}>Dia 8</option>
                  <option value={15}>Dia 15</option>
                  <option value={21}>Dia 21</option>
                  <option value={25}>Dia 25</option>
                </select>
              </div>

              <div className="form-group">
                <label>
                  Valor Total (R$) * 
                  {formData.tipo_cliente === 'cpf' && produtosSelecionados.length > 0 && (
                    <span className="auto-fill-badge">Soma dos produtos PF</span>
                  )}
                  {formData.tipo_cliente === 'cnpj' && operadoraObj?.planos_habilitados && planosList.length > 0 && (
                    <span className="auto-fill-badge">
                      {planoSelecionadoId ? 'Valor do plano selecionado' : 'Selecione um plano acima'}
                    </span>
                  )}
                </label>
                <input
                  type="text"
                  name="valor_total"
                  value={formData.valor_total}
                  onChange={handleChange}
                  placeholder={
                    formData.tipo_cliente === 'cpf' && produtosSelecionados.length > 0
                      ? 'Soma automática'
                      : (operadoraObj?.planos_habilitados && planosList.length > 0 ? 'Selecione um plano' : '0,00')
                  }
                  className={`${errors.valor_total ? 'error' : ''} ${
                    (formData.tipo_cliente === 'cpf' && produtosSelecionados.length > 0) ||
                    (formData.tipo_cliente === 'cnpj' && operadoraObj?.planos_habilitados && planosList.length > 0 && typeof planoSelecionadoId === 'number')
                      ? 'readonly-input' : ''
                  }`}
                  readOnly={
                    (formData.tipo_cliente === 'cpf' && produtosSelecionados.length > 0) ||
                    (formData.tipo_cliente === 'cnpj' && operadoraObj?.planos_habilitados && planosList.length > 0 && typeof planoSelecionadoId === 'number')
                  }
                />
                {errors.valor_total && <span className="error-text">{errors.valor_total}</span>}
                {formData.tipo_cliente === 'cnpj' && operadoraObj?.planos_habilitados && planosList.length > 0 && !planoSelecionadoId && (
                  <span className="info-text" style={{ fontSize: '0.75rem', color: '#ff9800', marginTop: '0.25rem', display: 'block' }}>
                    ⚠️ Selecione um plano para preencher o valor automaticamente
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* Observações */}
          <div className="form-section">
            <h2>📝 Observação da Venda</h2>
            {/* Mostrar nome do plano selecionado */}
            {/* Produtos PF ou plano selecionado */}
            {formData.tipo_cliente === 'cpf' && produtosSelecionados.length > 0 && (
              <div style={{
                marginBottom: '1rem',
                padding: '0.75rem 1rem',
                background: 'rgba(0, 191, 255, 0.1)',
                borderRadius: '8px',
                borderLeft: '4px solid var(--azul-dvs)'
              }}>
                <strong style={{ color: 'var(--azul-dvs)' }}>📦 Produtos PF:</strong>
                <ul style={{ margin: '0.5rem 0 0', paddingLeft: '1.25rem' }}>
                  {produtosSelecionados.map(p => (
                    <li key={p.catalogo_plano_id}>
                      {p.nome_neo} — Qtd {p.quantidade} — R$ {maskMoney(String(Number(p.valor_negociado).toFixed(2)))}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {formData.tipo_cliente === 'cnpj' && planoSelecionadoId && (
              <div style={{ 
                marginBottom: '1rem', 
                padding: '0.75rem 1rem', 
                background: 'rgba(0, 191, 255, 0.1)', 
                borderRadius: '8px',
                borderLeft: '4px solid var(--azul-dvs)'
              }}>
                <strong style={{ color: 'var(--azul-dvs)' }}>📋 Plano selecionado:</strong>
                <span style={{ marginLeft: '0.5rem', color: 'var(--texto-primario)' }}>
                  {planoSelecionadoId === PLANO_MANUAL_ID ? 'Plano manual' : planosList.find(p => p.id === planoSelecionadoId)?.nome}
                </span>
                <p style={{ fontSize: '0.8rem', color: 'var(--texto-secundario)', marginTop: '0.25rem', marginBottom: 0 }}>
                  {planoSelecionadoId === PLANO_MANUAL_ID
                    ? 'Descrição e valor informados no modal serão usados na observação e no valor total.'
                    : 'Este nome será adicionado automaticamente no início da observação ao salvar.'}
                </p>
              </div>
            )}
            <div className="form-group">
              <label>Observação Geral (opcional)</label>
              <textarea
                name="observacao_venda"
                value={formData.observacao_venda}
                onChange={handleChange}
                placeholder="Digite observações gerais sobre esta venda, descreva o pacote ofertado ao cliente detalhadamente..."
                rows="4"
              />
            </div>
          </div>

          {/* Documentos Anexos */}
          <div className="form-section">
            <h2>📎 Documentos Anexos (Opcional)</h2>
            <div className="form-group">
              <label>Arquivos (JPEG, JPG, PNG ou PDF - máximo 10MB cada, até 5 arquivos)</label>
              <input
                type="file"
                accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/jpg,image/png,application/pdf"
                multiple
                onChange={(e) => {
                  const files = Array.from(e.target.files || []);
                  
                  // Validar quantidade máxima (5 arquivos)
                  if (documentosAnexos.length + files.length > 5) {
                    alert('❌ Você pode anexar no máximo 5 arquivos por venda');
                    e.target.value = '';
                    return;
                  }
                  
                  // Validar cada arquivo
                  const validFiles = [];
                  for (const file of files) {
                    // Validar tamanho (10MB)
                    if (file.size > 10 * 1024 * 1024) {
                      alert(`❌ O arquivo "${file.name}" deve ter no máximo 10MB`);
                      continue;
                    }
                    // Validar tipo - apenas JPEG, JPG, PNG ou PDF
                    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
                    if (!validTypes.includes(file.type)) {
                      alert(`❌ O arquivo "${file.name}" deve ser uma imagem (JPEG, JPG, PNG) ou PDF`);
                      continue;
                    }
                    validFiles.push(file);
                  }
                  
                  if (validFiles.length > 0) {
                    setDocumentosAnexos(prev => [...prev, ...validFiles]);
                  }
                  
                  e.target.value = '';
                }}
                disabled={documentosAnexos.length >= 5}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  background: 'var(--cinza-escuro-2)',
                  border: '1px solid var(--border-color)',
                  borderRadius: '8px',
                  color: 'var(--texto-primario)',
                  cursor: documentosAnexos.length >= 5 ? 'not-allowed' : 'pointer',
                  opacity: documentosAnexos.length >= 5 ? 0.6 : 1
                }}
              />
              {documentosAnexos.length > 0 && (
                <div style={{ marginTop: '1rem' }}>
                  <div style={{ 
                    marginBottom: '0.5rem', 
                    color: 'var(--texto-primario)', 
                    fontSize: '0.875rem',
                    fontWeight: '500'
                  }}>
                    Arquivos anexados ({documentosAnexos.length}/5):
                  </div>
                  {documentosAnexos.map((file, index) => (
                    <div 
                      key={index}
                      style={{ 
                        marginTop: '0.5rem', 
                        padding: '0.75rem', 
                        background: 'var(--cinza-escuro-2)', 
                        borderRadius: '6px', 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center' 
                      }}
                    >
                      <span style={{ color: 'var(--texto-primario)', flex: 1 }}>
                        📄 {file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)
                      </span>
                      <button
                        type="button"
                        onClick={() => {
                          setDocumentosAnexos(prev => prev.filter((_, i) => i !== index));
                        }}
                        style={{
                          background: '#d32f2f',
                          color: 'white',
                          border: 'none',
                          padding: '0.25rem 0.75rem',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '0.875rem',
                          marginLeft: '0.5rem'
                        }}
                      >
                        Remover
                      </button>
                    </div>
                  ))}
                </div>
              )}
              {documentosAnexos.length >= 5 && (
                <div style={{ 
                  marginTop: '0.5rem', 
                  color: '#ff9800', 
                  fontSize: '0.875rem' 
                }}>
                  ⚠️ Limite de 5 arquivos atingido. Remova um arquivo para adicionar outro.
                </div>
              )}
            </div>
          </div>

          {/* Botões */}
          <div className="form-actions">
            <button
              type="button"
              onClick={() => navigate('/vendas')}
              className="btn-secondary"
              disabled={loading}
            >
              ❌ Cancelar
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={loading || consultandoEmpresas}
            >
              {consultandoEmpresas ? '⏳ Consultando...' : loading ? '⏳ Salvando...' : '✅ Cadastrar Venda'}
            </button>
          </div>
        </form>

        {/* Modal Plano manual */}
        {showPlanoManualModal && (
          <div className="modal-overlay" onClick={cancelarPlanoManual}>
            <div className="modal-content modal-plano-manual" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>Plano manual</h2>
                <button type="button" className="modal-close" onClick={cancelarPlanoManual} aria-label="Fechar">✕</button>
              </div>
              <div className="modal-body">
                <p className="modal-plano-manual-desc">Informe a descrição do plano (será salva na observação) e o valor.</p>
                <div className="form-group">
                  <label>Descrição do plano (vai para observação) *</label>
                  <textarea
                    value={planoManualForm.texto}
                    onChange={(e) => setPlanoManualForm(prev => ({ ...prev, texto: e.target.value }))}
                    placeholder="Ex.: Internet 200 Mega + TV por assinatura"
                    rows={3}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label>Valor (R$) *</label>
                  <input
                    type="text"
                    value={planoManualForm.valor}
                    onChange={(e) => setPlanoManualForm(prev => ({ ...prev, valor: maskMoney(e.target.value) }))}
                    placeholder="0,00"
                    className="form-control"
                  />
                </div>
                <div className="modal-actions">
                  <button type="button" className="btn-secondary" onClick={cancelarPlanoManual}>
                    Cancelar
                  </button>
                  <button type="button" className="btn-primary" onClick={confirmarPlanoManual}>
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal CNPJs disponíveis para o CPF */}
        {showCnpjDisponivelModal && (
          <div className="modal-overlay" onClick={() => setShowCnpjDisponivelModal(false)}>
            <div className="modal-content modal-cnpj-disponivel" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>🏢 CNPJ(s) vinculado(s) ao CPF</h2>
                <button type="button" className="modal-close" onClick={() => setShowCnpjDisponivelModal(false)} aria-label="Fechar">✕</button>
              </div>
              <div className="modal-body">
                <p className="modal-cnpj-disponivel-desc">
                  Este cliente possui o seguinte CNPJ ou CNPJs vinculados ao CPF informado:
                </p>
                <ul className="cnpj-disponivel-lista">
                  {empresasDisponiveis.map((empresa) => (
                    <li key={empresa.cnpj} className="cnpj-disponivel-item">
                      <strong>{maskCNPJ(empresa.cnpj)}</strong>
                      <span>{empresa.razao_social}</span>
                    </li>
                  ))}
                </ul>

                {etapaCnpjModal === 'selecionar' && empresasDisponiveis.length > 1 && (
                  <div className="cnpj-selecao-grupo">
                    <p className="modal-cnpj-disponivel-desc">Selecione o CNPJ para seguir com o cadastro:</p>
                    {empresasDisponiveis.map((empresa) => (
                      <label key={empresa.cnpj} className="cnpj-radio-option">
                        <input
                          type="radio"
                          name="cnpj_selecionado"
                          value={empresa.cnpj}
                          checked={cnpjSelecionado === empresa.cnpj}
                          onChange={() => setCnpjSelecionado(empresa.cnpj)}
                        />
                        <span>
                          <strong>{maskCNPJ(empresa.cnpj)}</strong> — {empresa.razao_social}
                        </span>
                      </label>
                    ))}
                  </div>
                )}

                <div className="modal-actions">
                  {etapaCnpjModal === 'escolha' ? (
                    <>
                      <button type="button" className="btn-secondary" onClick={handleContinuarComoCpf}>
                        Continuar como CPF
                      </button>
                      <button type="button" className="btn-primary" onClick={handleIrParaSelecaoCnpj}>
                        Seguir com CNPJ
                      </button>
                    </>
                  ) : (
                    <>
                      <button type="button" className="btn-secondary" onClick={() => setEtapaCnpjModal('escolha')}>
                        Voltar
                      </button>
                      <button
                        type="button"
                        className="btn-primary"
                        onClick={handleConfirmarCnpjSelecionado}
                        disabled={buscandoCnpj || (empresasDisponiveis.length > 1 && !cnpjSelecionado)}
                      >
                        {buscandoCnpj ? '⏳ Consultando CNPJ...' : 'Confirmar CNPJ'}
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal RG do representante (conversão CPF → CNPJ) */}
        {showRgModal && (
          <div className="modal-overlay" onClick={() => setShowRgModal(false)}>
            <div className="modal-content modal-plano-manual" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>RG do Representante</h2>
                <button type="button" className="modal-close" onClick={() => setShowRgModal(false)} aria-label="Fechar">✕</button>
              </div>
              <div className="modal-body">
                <p className="modal-plano-manual-desc">
                  Para cadastrar como CNPJ, informe o RG do representante legal.
                </p>
                <div className="form-group">
                  <label>RG *</label>
                  <input
                    type="text"
                    value={rgTemp}
                    onChange={(e) => setRgTemp(e.target.value)}
                    placeholder="Número do RG"
                    className="form-control"
                  />
                </div>
                <div className="modal-actions">
                  <button type="button" className="btn-secondary" onClick={() => setShowRgModal(false)}>
                    Cancelar
                  </button>
                  <button type="button" className="btn-primary" onClick={handleConfirmarRg}>
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal Resumo da Venda */}
        {showResumoModal && (
          <div className="modal-overlay" onClick={() => setShowResumoModal(false)}>
            <div className="modal-content modal-resumo-venda" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h2>📋 Resumo da Venda</h2>
                <button type="button" className="modal-close" onClick={() => setShowResumoModal(false)} aria-label="Fechar">✕</button>
              </div>
              <div className="modal-body modal-resumo-body">
                <p className="resumo-subtitle">Confira os dados da venda antes de enviar:</p>
                
                {/* Dados do Cliente */}
                <div className="resumo-section">
                  <h3>👤 Dados do Cliente</h3>
                  <div className="resumo-grid">
                    <div className="resumo-item">
                      <span className="resumo-label">Tipo:</span>
                      <span className="resumo-value">{formData.tipo_cliente === 'cpf' ? 'Pessoa Física' : 'Pessoa Jurídica'}</span>
                    </div>
                    <div className="resumo-item">
                      <span className="resumo-label">Documento:</span>
                      <span className="resumo-value">{formData.documento}</span>
                    </div>
                    <div className="resumo-item">
                      <span className="resumo-label">Nome:</span>
                      <span className="resumo-value">{formData.tipo_cliente === 'cnpj' ? formData.razao_social : formData.nome_cliente}</span>
                    </div>
                    <div className="resumo-item">
                      <span className="resumo-label">Telefone 1:</span>
                      <span className="resumo-value">{formData.telefone}</span>
                    </div>
                    {formData.telefone2 && (
                      <div className="resumo-item">
                        <span className="resumo-label">Telefone 2:</span>
                        <span className="resumo-value">{formData.telefone2}</span>
                      </div>
                    )}
                    <div className="resumo-item">
                      <span className="resumo-label">Email:</span>
                      <span className="resumo-value">{formData.email}</span>
                    </div>
                    {formData.tipo_cliente === 'cpf' && (
                      <>
                        <div className="resumo-item">
                          <span className="resumo-label">Data de Nascimento:</span>
                          <span className="resumo-value">{formatarData(formData.data_nascimento)}</span>
                        </div>
                        <div className="resumo-item">
                          <span className="resumo-label">Nome da Mãe:</span>
                          <span className="resumo-value">{formData.nome_mae}</span>
                        </div>
                      </>
                    )}
                    {formData.tipo_cliente === 'cnpj' && (
                      <>
                        <div className="resumo-item">
                          <span className="resumo-label">Razão Social:</span>
                          <span className="resumo-value">{formData.razao_social}</span>
                        </div>
                        <div className="resumo-item">
                          <span className="resumo-label">Estado do CNPJ:</span>
                          <span className="resumo-value">{formData.estado_cnpj || '-'}</span>
                        </div>
                        <div className="resumo-item">
                          <span className="resumo-label">Representante:</span>
                          <span className="resumo-value">{formData.nome_representante}</span>
                        </div>
                        <div className="resumo-item">
                          <span className="resumo-label">CPF Representante:</span>
                          <span className="resumo-value">{formData.cpf}</span>
                        </div>
                        <div className="resumo-item">
                          <span className="resumo-label">RG:</span>
                          <span className="resumo-value">{formData.rg || '-'}</span>
                        </div>
                        <div className="resumo-item">
                          <span className="resumo-label">Data de Nascimento:</span>
                          <span className="resumo-value">{formatarData(formData.data_nascimento)}</span>
                        </div>
                        <div className="resumo-item">
                          <span className="resumo-label">Nome da Mãe:</span>
                          <span className="resumo-value">{formData.nome_mae}</span>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {/* Dados PAP - Apenas se preenchidos */}
                {exigeCamposPap && formData.vendedor_codigo_pap && (
                  <div className="resumo-section">
                    <h3>📋 Dados PAP ({formatMarcaLabel(formData.marca)})</h3>
                    <div className="resumo-grid">
                      <div className="resumo-item">
                        <span className="resumo-label">Marca:</span>
                        <span className="resumo-value">{formatMarcaLabel(formData.marca)}</span>
                      </div>
                      <div className="resumo-item">
                        <span className="resumo-label">Código PAP:</span>
                        <span className="resumo-value">{formData.vendedor_codigo_pap}</span>
                      </div>
                      <div className="resumo-item">
                        <span className="resumo-label">Login PAP:</span>
                        <span className="resumo-value">{formData.vendedor_login_pap}</span>
                      </div>
                      {marcaExigeNumeroOrdem(formData.marca) && formData.numero_ordem && (
                        <div className="resumo-item">
                          <span className="resumo-label">Número da Ordem:</span>
                          <span className="resumo-value">{formData.numero_ordem}</span>
                        </div>
                      )}
                      {marcaExigeNumeroOrdem(formData.marca) && formData.data_instalacao && (
                        <div className="resumo-item">
                          <span className="resumo-label">Data da Instalação:</span>
                          <span className="resumo-value">{formatarData(formData.data_instalacao)}</span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {formData.tipo_cliente === 'cpf' && formData.marca && !exigeCamposPap && (
                  <div className="resumo-section">
                    <h3>🏷️ Marca</h3>
                    <div className="resumo-grid">
                      <div className="resumo-item">
                        <span className="resumo-label">Marca:</span>
                        <span className="resumo-value">{formatMarcaLabel(formData.marca)}</span>
                      </div>
                    </div>
                  </div>
                )}

                {/* Endereço */}
                <div className="resumo-section">
                  <h3>📍 Endereço</h3>
                  <div className="resumo-grid">
                    <div className="resumo-item resumo-item-full">
                      <span className="resumo-label">Endereço:</span>
                      <span className="resumo-value">
                        {formData.logradouro}, {formData.numero}
                        {(() => {
                          const comps = formData.tipo_cliente === 'cnpj'
                            ? Object.values(serializarComplementosCnpj(complementosCnpj)).filter(Boolean)
                            : [formData.complemento1, formData.complemento2].filter(Boolean);
                          return comps.map((c) => ` - ${c}`).join('');
                        })()}
                      </span>
                    </div>
                    <div className="resumo-item">
                      <span className="resumo-label">Bairro:</span>
                      <span className="resumo-value">{formData.bairro}</span>
                    </div>
                    <div className="resumo-item">
                      <span className="resumo-label">CEP:</span>
                      <span className="resumo-value">{formData.cep}</span>
                    </div>
                    <div className="resumo-item">
                      <span className="resumo-label">Cidade:</span>
                      <span className="resumo-value">{formData.cidade}</span>
                    </div>
                    <div className="resumo-item">
                      <span className="resumo-label">Estado:</span>
                      <span className="resumo-value">{formData.estado_completo} ({formData.estado})</span>
                    </div>
                  </div>
                </div>

                {/* Operadora e Plano */}
                {operadoraSelecionada && (
                  <div className="resumo-section">
                    <h3>📡 Operadora e Plano</h3>
                    <div className="resumo-grid">
                      <div className="resumo-item">
                        <span className="resumo-label">Operadora:</span>
                        <span className="resumo-value">{operadoraSelecionada.charAt(0).toUpperCase() + operadoraSelecionada.slice(1)}</span>
                      </div>
                      {planoSelecionadoId && planoSelecionadoId !== PLANO_MANUAL_ID && (
                        <div className="resumo-item">
                          <span className="resumo-label">Plano:</span>
                          <span className="resumo-value">{planosList.find(p => p.id === planoSelecionadoId)?.nome}</span>
                        </div>
                      )}
                      {planoSelecionadoId === PLANO_MANUAL_ID && (
                        <div className="resumo-item resumo-item-full">
                          <span className="resumo-label">Plano Manual:</span>
                          <span className="resumo-value">{formData.observacao_venda}</span>
                        </div>
                      )}
                      {envioAceiteSelecionado && (
                        <div className="resumo-item">
                          <span className="resumo-label">Envio de Aceite:</span>
                          <span className="resumo-value">
                            <MeioEnvioLabel meio={envioAceiteSelecionado} iconSize={20} />
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Agendamento */}
                <div className="resumo-section">
                  <h3>📅 Agendamento de Instalação</h3>
                  <div className="resumo-grid">
                    <div className="resumo-item">
                      <span className="resumo-label">Opção 1:</span>
                      <span className="resumo-value">{formatarData(formData.data_agendamento1)} - {formatarPeriodo(formData.periodo_agendamento1)}</span>
                    </div>
                    {formData.data_agendamento2 && (
                      <div className="resumo-item">
                        <span className="resumo-label">Opção 2:</span>
                        <span className="resumo-value">{formatarData(formData.data_agendamento2)}{formData.periodo_agendamento2 ? ` - ${formatarPeriodo(formData.periodo_agendamento2)}` : ''}</span>
                      </div>
                    )}
                    <div className="resumo-item">
                      <span className="resumo-label">Aceita Antecipação:</span>
                      <span className="resumo-value">{formData.aceita_antecipacao ? 'Sim' : 'Não'}</span>
                    </div>
                    {formData.observacao_instalacao && (
                      <div className="resumo-item resumo-item-full">
                        <span className="resumo-label">Obs. Instalação:</span>
                        <span className="resumo-value">{formData.observacao_instalacao}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Informações Financeiras */}
                <div className="resumo-section">
                  <h3>💰 Informações Financeiras</h3>
                  <div className="resumo-grid">
                    <div className="resumo-item">
                      <span className="resumo-label">Valor Total:</span>
                      <span className="resumo-value valor-destaque">R$ {formData.valor_total}</span>
                    </div>
                    <div className="resumo-item">
                      <span className="resumo-label">Vencimento:</span>
                      <span className="resumo-value">Dia {formData.data_vencimento}</span>
                    </div>
                  </div>
                </div>

                {/* Observação */}
                {formData.observacao_venda && planoSelecionadoId !== PLANO_MANUAL_ID && (
                  <div className="resumo-section">
                    <h3>📝 Observação</h3>
                    <div className="resumo-observacao">
                      {formData.observacao_venda}
                    </div>
                  </div>
                )}

                {/* Documentos Anexos */}
                {documentosAnexos.length > 0 && (
                  <div className="resumo-section">
                    <h3>📎 Documentos Anexos</h3>
                    <div className="resumo-arquivos">
                      {documentosAnexos.map((file, index) => (
                        <span key={index} className="resumo-arquivo">
                          📄 {file.name}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {/* Vendedor (apenas para supervisor) */}
                {user?.role === 'supervisor' && opcoesVendedor.length > 0 && (
                  <div className="resumo-section">
                    <h3>👤 Vendedor Responsável</h3>
                    <div className="resumo-grid">
                      <div className="resumo-item">
                        <span className="resumo-label">Vendedor:</span>
                        <span className="resumo-value">{opcoesVendedor.find(opt => opt.value === vendedorId)?.label || '-'}</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-actions">
                <button type="button" className="btn-secondary" onClick={() => setShowResumoModal(false)} disabled={loading}>
                  ❌ Cancelar
                </button>
                <button type="button" className="btn-primary" onClick={confirmarEnvioVenda} disabled={loading}>
                  {loading ? '⏳ Enviando...' : '✅ Confirmar Envio'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default NovaVenda;
